export default __webpack_public_path__ + "static/womanChargerReeddiCapsule-855a8526281b5a6529d5218ed2b9b7cd.png";